<script>
import { mapActions, mapGetters } from 'vuex'
import { formatDate } from '@lib/utils/format-date'
import HierarchyTreeEditor from '../category-hierarchy/hierarchy-tree-editor.vue'

export default {
  name: 'ProductCategoryTreeDetails',
  components: {
    HierarchyTreeEditor,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      category: [],
      data: {
        tree: {},
      },
      depth: 0,
      modals: {
        delete: false,
      },
      backRoute: { name: 'product-category-trees' },
    }
  },
  computed: {
    ...mapGetters('me', [
      'canUpdateCategoryTree',
      'canDeleteCategoryTree',
    ]),
    title() {
      return this.category.name || 'Product Category Tree'
    },
    type() {
      switch (this.depth) {
        case 3:
          return 'groups'
        case 2:
          return 'tiers'
        default:
          return 'categories'
      }
    },
    dropdownItems() {
      const items = []

      if (this.canUpdateCategoryTree) {
        items.push({
          label: 'Edit Category Tree',
          action: this.onEditClick,
        })
      }

      if (this.canDeleteCategoryTree) {
        items.push({
          label: 'Delete Category Tree',
          action: this.onDeleteClick,
        })
      }

      return items
    },
  },
  async created() {
    this.loading = true

    const [err, response] = await this.getCategoryTree(this.id)

    if (err) {
      this.getErrorMessage(err, 'Category Tree', 'ID', this.id)
    } else {
      this.depth = this.getDepth(response)
      this.category = response
      this.data.tree = response.categories
      await this.storeTree(this.category.categories)
    }

    this.loading = false
  },
  methods: {
    ...mapActions('category', ['getCategory', 'storeTree']),
    ...mapActions('categoriesTree', ['getCategoryTree']),
    onDeleteClick() {
      this.$modal.show('delete-category', {
        props: {
          category: this.category,
        },
      })
    },
    onEditClick() {
      this.$router.push({
        name: 'category-hierarchy',
        params: {
          id: this.id,
          category: this.category,
        },
      })
    },
    formatDate(value) {
      return formatDate(value, 'DD/MM/YYYY hh:mm')
    },
    getDepth(item, depth = 0) {
      const items = item.categories || item.items
      if (items.length) {
        return this.getDepth(items[0], depth + 1)
      }
      return depth
    },
  },
}
</script>

<template>
  <main-layout
    :title="title"
    :back="backRoute"
    :loading="loading"
    :error-message="errorMessageText"
  >
    <el-dropdown
      v-if="dropdownItems.length && !errorMessageText"
      slot="header"
      trigger="click"
    >
      <dropdown-icon />
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(item, index) of dropdownItems"
          :key="index"
          @click.native="item.action"
        >
          {{ item.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <data-box
      v-loading="loading"
      header="Category Tree Details"
      :status="false"
    >
      <data-list
        v-if="!loading"
      >
        <dt>Date Created</dt>
        <dd>{{ formatDate(category.created_at) || '-' }}</dd>

        <dt>Last Updated</dt>
        <dd>{{ formatDate(category.updated_at) || '-' }}</dd>
      </data-list>

      <el-form
        :model="data"
      >
        <hierarchy-tree-editor
          :value="category.categories"
          :view-mode="true"
          :type="type"
        />
      </el-form>
    </data-box>
  </main-layout>
</template>

<style lang="scss" module>
.noBold {
  font-weight: normal;
}

.group {
  margin-bottom: 1rem;
}

.levels {
  display: flex;
  flex-wrap: wrap;
  padding-top: 1rem;
  font-weight: normal;

  dt {
    min-width: 6rem;
  }

  dd {
    // flex-grow: 1;
    width: calc(100% - 6rem);
  }
}
</style>
